import React, { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating';
import { Modal, Button } from 'react-bootstrap';
import Comments from './Comments';
import StarIcon from '@mui/icons-material/Star';
import Box from '@mui/material/Box';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { toast } from 'react-toastify';
import swal from "@sweetalert/with-react";
import { db,auth } from '../../../../../firebase';

const labels = {
    0.5: '0.5 Useless',
    1: '1 Useless+',
    1.5: '1.5 Poor',
    2: '2 Poor+',
    2.5: '2.5 Ok',
    3: '3 Ok+',
    3.5: '3.5 Good',
    4: '4 Good+',
    4.5: '4.5 Excellent',
    5: '5 Excellent+',
  };

  function getLabelText(value) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
  }
  
function Reviews({ menuId, branchId, restId }) {
    const [show, setShow] = useState(false);
    const [posts, setPosts] = useState([])
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [value, setValue] = React.useState(0);
    const [hover, setHover] = React.useState(-1);
    const [comment, setComment] = useState('')
    const [countReviews, setCountReviews] = useState(0)

    useEffect(() => {
        db.collection('reviews').where("menuId","==", menuId)
       .onSnapshot(snapshot => (
        setCountReviews(snapshot.docs.length)
       ))
    }, []);
    function abbrNum(number, decPlaces) {
      // 2 decimal places => 100, 3 => 1000, etc
      decPlaces = Math.pow(10,decPlaces);
    
      // Enumerate number abbreviations
      var abbrev = [ "K", "M", "B", "T" ];
    
      // Go through the array backwards, so we do the largest first
      for (var i=abbrev.length-1; i>=0; i--) {
    
          // Convert array index to "1000", "1000000", etc
          var size = Math.pow(10,(i+1)*3);
    
          // If the number is bigger or equal do the abbreviation
          if(size <= number) {
               // Here, we multiply by decPlaces, round, and then divide by decPlaces.
               // This gives us nice rounding to a particular decimal place.
               number = Math.round(number*decPlaces/size)/decPlaces;
    
               // Add the letter for the abbreviation
               number += abbrev[i];
    
               // We are done... stop
               break;
          }
      }
    
      return number;
    }

    useEffect(() => {
        db.collection('reviews').where("menuId","==",menuId).onSnapshot(snapshot => {
            setPosts(snapshot.docs.map(doc => ({
                id: doc.id,
                post: doc.data(),
            })));
        })
    }, []);

   const totalRatings = (posts.reduce((a,v) =>  a = a + v.post.rating , 0 ))
   const numberOfRatings = posts.length
   const rating = totalRatings / numberOfRatings
   var a = Math.round(rating * 10) / 10


   const submitReview = () => {
       if(value === 0){
           toast.error("Kindly rate the stars!")
       }else if(value === null){
        toast.error("Kindly rate the stars!")
    }else{
        db.collection("reviews").add({
            branch:"Branch Name",
            menu:"Menu Name",
            ratedByName:"Uwimana Jessy",
            branchId,
            menuId,
            ratedByPhone:"+254746749307",
            ratedByUid:auth?.currentUser?.uid,
            rating:value,
            ratingComment:comment,
            ratingTime: Date.now(),
            restId
        }).
        then((e)=> 
        console.log(e),
        handleClose(),
        setValue(0),
        setComment(""),
        swal("Thanks for your feedback ✔️!")
        )
       }
   }

  return (
    <div>
                <div className="bg-white rounded shadow-sm p-0 mb-2 rating-review-select-page">

                    {auth?.currentUser?.uid ?(
        <div onClick={handleShow} className="mb-4">
        <center style={{fontWeight:'bold',cursor:'pointer'}}>Kindly Rate Us!</center>
        <center><Rating style={{cursor:'pointer'}} name="half-rating-read" value={a} precision={0.5} readOnly />
        </center> 
        <center><span style={{fontWeight:'600'}}>Rating(s): {numberOfRatings === 0 ?(<>0</>):(<>{a}</>)}/5</span> <a style={{fontWeight:'bold',cursor:'pointer'}}>({abbrNum(numberOfRatings, 0)} Review(s))</a></center>         
    </div>
                    ):(
                        <div onClick={() => alert("Kindly Sign In first.\nThanks!")} className="mb-4">
                        <center style={{fontWeight:'bold',cursor:'pointer'}}>Kindly Rate Us!</center>
                        <center><Rating style={{cursor:'pointer'}} name="half-rating-read" value={a} precision={0.5} readOnly />
                        </center> 
                        <center><span style={{fontWeight:'600'}}>Rating(s): {numberOfRatings === 0 ?(<>0</>):(<>{a}</>)}/5</span> <a style={{fontWeight:'bold',cursor:'pointer'}}>({abbrNum(numberOfRatings, 0)}Review(s))</a></center>         
                    </div>
                    )}

        <hr />
         <Comments menuId={menuId} branchId={branchId} restId={restId}/>
      </div>


      <Modal show={show} onHide={handleClose}>

        <Modal.Body>
        <div className="bg-white rounded shadow-sm p-0 mb-2 rating-review-select-page">
        <div className="mb-4">
            <center style={{fontWeight:'bold'}}>Kindly Rate Us!</center>
            <center>
            <Box
      sx={{
        width: 200,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Rating
        name="hover-feedback"
        value={value}
        precision={0.5}
        getLabelText={getLabelText}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
      />
      {value !== null && (
        <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
      )}
    </Box>
            </center> 
        </div>
        <form>
          <div className="form-group">
            <textarea className="form-control" value={comment} onChange={e => setComment(e.target.value)}  placeholder={"Your Comment..."} />
          </div>
          <div className="form-group">
            <button onClick={submitReview} className="btn btn-primary btn-sm" type="button"> Submit Comment </button>
          </div>
        </form>
      </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
              
    </div>
  )
}

export default Reviews